<template>
  <nav class="well-top-wrap ocr-tabs-bar ocr-sidebar-nav" aria-label="OCR pages">
    <div class="tabs-data">
      <div class="tabs-toggle">
        <v-tabs
          :model-value="activeTab"
          color="primary"
          grow
          show-arrows
          @update:model-value="onTabChange"
        >
          <v-tab v-for="item in items" :key="item.value" :value="item.value">
            {{ item.label }}
          </v-tab>
        </v-tabs>
      </div>
    </div>
  </nav>
</template>

<script>
const TAB_ROUTES = {
  dashboard: "dashboard",
  upload: "upload",
  reports: "reports",
  configuration: "configuration",
  "test-data": "test-data",
};

export default {
  name: "OcrSubNav",
  computed: {
    tenantPrefix() {
      return this.$route.params.tenantPrefix;
    },
    items() {
      return [
        { label: "Dashboard", value: "dashboard" },
        { label: "File Upload", value: "upload" },
        { label: "Process Reports", value: "reports" },
        { label: "Configuration", value: "configuration" },
        { label: "Test Data", value: "test-data" },
      ];
    },
    activeTab() {
      const segment = this.$route.path.split("/").filter(Boolean).pop();
      if (segment && TAB_ROUTES[segment]) return segment;
      if (this.$route.path.includes("/ocr/upload")) return "upload";
      return "dashboard";
    },
  },
  methods: {
    onTabChange(value) {
      const segment = TAB_ROUTES[value] || value;
      const path = `/${this.tenantPrefix}/ocr/${segment}`;
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    },
  },
};
</script>
